
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/tv3/marato/instruccions-ingres",
      function () {
        return require("private-next-pages/corporatiu/tv3/marato/instruccions-ingres/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/tv3/marato/instruccions-ingres"])
      });
    }
  